<template>
    <div class="container-center">
        <el-tabs v-model="activeName" type="card" class="tabs">
            <el-tab-pane label="招标类" name="invitation">
                <msg-list  :type-name="activeName"  v-if="activeName == 'invitation'"/>
            </el-tab-pane>
            <el-tab-pane label="工程管理类" name="project">
                <msg-list :type-name="activeName" v-if="activeName == 'project'"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import msgList from './comps/msgexList';
export default {
    name:'messageTabs',
    components:{ msgList },
    data(){
        return {
            activeName:'invitation'
        }

    },
    methods:{

    }
    
}
</script>


<style lang="postcss" scoped>
.tabs{
    margin-top:25px;
}
</style>




// WEBPACK FOOTER //
// src/pages/dsp/msgex/messageTabs.vue